import { TaskBasic } from '@/tracker/types';

import { GroupBy, GROUPS, IssueGroup } from './config';

/** Группы по загруженным задачам; порядок задач внутри группы — как отдал сервер */
export const groupIssues = ({
  issues,
  groupBy,
}: {
  issues: TaskBasic[];
  groupBy: GroupBy;
}): IssueGroup[] => {
  if (groupBy === 'none') return [{ id: '', title: '', issues }];

  const config = GROUPS[groupBy];
  const ordered = config.compare ? [...issues].sort(config.compare) : issues;
  const groups = new Map<string, IssueGroup>();

  ordered.forEach((issue) => {
    const { id, title } = config.groupOf(issue);
    const group = groups.get(id) ?? { id, title, issues: [] };

    group.issues.push(issue);
    groups.set(id, group);
  });

  return [...groups.values()];
};
